import React from "react"
import styled from "styled-components"

import { Container, Row, Col } from "../Grid"
import Snippet from "../Snippet"
import IconWithTextGrid from "../IconWithTextGrid"

import { media, mixins } from "../../styles"

const Wrapper = styled.div``

const Header = styled.div`
  margin: 0 0 30px;
  text-align: center;

  @media ${media.lg} {
    margin-bottom: 70px;
  }

  h2 {
    ${mixins.title3}
  }
`

const HowWeWork = ({ workMethods }) => {
  return (
    <Wrapper>
      <Container>
        <Header>
          <h2>
            <Snippet id="careersValues" field="header" />
          </h2>
        </Header>
        <Row>
          <Col md="10" mdOffset="1">
            <IconWithTextGrid items={workMethods} layout="illustration-round" />
          </Col>
        </Row>
      </Container>
    </Wrapper>
  )
}

export default HowWeWork
